import * as React from 'react';
import { FC } from 'react';
import Advert from './advert';
import useAdverts from './useAdverts';
import useBlockedPages from './useBlockedPages';

const Adverts: FC = () => {
  const { active, advert, close, accept } = useAdverts();

  return <div id="adverts">{active && advert ? <Advert advert={advert} close={close} accept={accept} /> : null}</div>;
};

const Wrapper: FC = () => {
  const blocked = useBlockedPages();

  return blocked ? null : <Adverts />;
};

export default Wrapper;
